import { useEffect, useState, useCallback } from 'react'
import { useParams } from 'react-router-dom'
import learningService from '../service'
import { StudentData, StudentDetailsRequest, StudentDetailsResponse } from '../service/types/interfaces'

export const useAnalyticalReport = () => {
  const { groupId } = useParams<{ groupId: string }>()
  const [data, setData] = useState<StudentData[]>([])
  const [loadingData, setLoadingData] = useState(true)

  useEffect(() => {
    if (groupId) {
      setLoadingData(true)
      learningService
        .getAnalyticalReport(groupId, [])
        .then(response => setData(response as any))
        .catch(error => console.error('Error fetching analytical report:', error))
        .finally(() => setLoadingData(false))
    }
  }, [groupId])

  return { data, loadingData }
}

export const useStudentDetails = (groupId: string | undefined) => {
  const [studentDetails, setStudentDetails] = useState<StudentDetailsResponse[] | null>(null)
  const [loadingDetails, setLoadingDetails] = useState(false)

  const formatId = (id: string) => {
    return id
      .toLowerCase()
      .replace(/([a-z0-9]{8})([a-z0-9]{4})([a-z0-9]{4})([a-z0-9]{4})([a-z0-9]{12})/, '$1-$2-$3-$4-$5')
  }

  const fetchStudentDetails = useCallback(
    (studentId: string, lv1ItemId: string) => {
      setLoadingDetails(true)
      const formattedId = formatId(lv1ItemId)
      const payload: StudentDetailsRequest = {
        group_id: groupId || '',
        lv1_item_id: formattedId,
        student_id: studentId,
      }
      learningService
        .getStudentDetails(payload)
        .then(response => setStudentDetails(response))
        .catch(error => console.error('Error fetching student details:', error))
        .finally(() => setLoadingDetails(false))
    },
    [groupId],
  )

  return { studentDetails, loadingDetails, fetchStudentDetails }
}
